module.exports = __webpack_public_path__ + "img/drops_background.10e8d50a.png";